import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AwardsFacetList from './components/AwardsFacetList';
import AwardsCard from './components/AwardsCard';

import { useFetch } from './hooks'

const AwardsCardListing = ({
  endpoint,
  language,
  noResultsLabel,
  resetBtnLabel,
  title,
  awardtypes
}) => {
  const [page, setPage] = useState(1);
  const [selectedFacets, setSelectedFacets] = useState({ awardtypes });
  const { totalPages, results, facets, loading } = useFetch(
    endpoint,
    language,
    page,
    selectedFacets
  );

  const handleButtonClick = () => {
    if (page < totalPages) setPage(page + 1);
  }

  const handleReset = () => {
    setSelectedFacets({});
    setPage(1);
  };

  const handleFilters = (keyword, value) => {
    const updatedFacets = {
      ...selectedFacets,
      [keyword]: value
    };

    setSelectedFacets(updatedFacets);
    setPage(1);
  };

  return (
    <>
      {title ? (<h2 className="awards-listing__title">{title}</h2>) : ('') }
      <div className="awards-listing__filters">
        <AwardsFacetList
          initialFacets={facets}
          selectedFacets={selectedFacets}
          onFiltersChange={handleFilters}
          onResetFilters={handleReset}
          resetBtnLabel={resetBtnLabel}
        />
      </div>
      <div>
        {!loading && !results?.length ? (
          <p>{noResultsLabel}</p>
        ) : (
          <div className="awards-listing__results">
            {results?.map((awa, i) => (
              <AwardsCard key={i} award={awa} />
            ))}
          </div>
        )}
        {loading ||
              (page < totalPages && (
                <div className="awards-listing__load-more">
                  <button
                    type="button"
                    className="btn-v2 btn--primary"
                    onClick={() => {
                      handleButtonClick();
                    }}>
                    <div className="btn-content">
                      <span>Load More</span>
                    </div>
                  </button>
                </div>
              ))}
      </div>
    </>
  );
};

AwardsCardListing.propTypes = {
  endpoint: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  noResultsLabel: PropTypes.string.isRequired,
  resetBtnLabel: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default React.memo(AwardsCardListing);
